<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.personal')}}
    Icon(icon="personal" classes="p-title__icon")
  Ownership(risk="personal" risk_object="incident")
  Ownership(risk="personal" risk_object="foresight")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Personal.vue